
import { NotificationManager } from 'react-light-notifications'
import { httpStatusCode } from '../errors/http-status-codes';

// The messages shown by default to the user when
// an http error is triggered.
const defaultHttpStatusMapping = new Map([
    [httpStatusCode.NOT_FOUND, {
        title: 'errori.errore',
        message: 'errori.entitaNonTrovata',
    }],
    [httpStatusCode.NOT_ACCEPTABLE, {
        title: 'errori.erroreValidazione',
        message: 'errori.datiIncompleti',
    }],
    [httpStatusCode.CONFLICT, {
        title: 'errori.errore',
        message: 'errori.servizioNonDisponibile',
    }],
    [httpStatusCode.UNPROCESSABLE_ENTITY, {
        title: 'errori.errore',
        message: 'errori.erroreInatteso',
    }],
    [httpStatusCode.INTERNAL_SERVER_ERROR, {
        title: 'errori.errore',
        message: 'errori.erroreInatteso',
    }],
    [httpStatusCode.BAD_GATEWAY, {
        title: 'errori.errore',
        message: 'errori.servizioNonDisponibile',
    }],
]);


export const responseUtils = {
    handleResponse,
    handleError
};

function handleResponse(response, intl, httpStatusMapping = defaultHttpStatusMapping) {
    if (response.ok) {
        return response.json();
    }

    return response.json()
        .then(jsonRes => {
            const httpStatus = response.status;
            const translationLabels = httpStatusMapping.get(httpStatus) ||
                defaultHttpStatusMapping.get(httpStatus);

            // Shows a toast notification.
            const { title, message } = translationLabels;
            NotificationManager.error({
                title: intl.formatMessage({ id: title || 'errori.errore' }),
                message: intl.formatMessage({ id: message || 'errori.erroreDiComunicazione' }),
                showCloseButton: true,
                timeout: 1000,
                priority: false,
            });

            // Propagates the error.
            return Promise.reject({ response, jsonRes });
        });
}

function handleError(error, intl) {
    NotificationManager.error({
        title: intl.formatMessage({ id: 'errori.errore' }),
        message: `${error.message || error}`,
        showCloseButton: true,
        timeout: 1000,
        priority: false,
    });
    return Promise.reject(error);
}